import SendPurchaseTokenError from './SendPurchaseTokenError';
class W8ContractNotSigned extends SendPurchaseTokenError {
    constructor(options) {
        super('Investor has not signed W8 contract', options);
    }
}
export default W8ContractNotSigned;
